import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Container } from 'reactstrap';

import {
  APIgetFilesGroups,
  APIgetFilesGroupsUsers,
} from '../api/Files';

import UploadsHeader from '../components/Uploads/Header';
import UploadsList from '../components/Uploads/List';
import UploadsFooter from '../components/Uploads/Footer';
import UploadsFilters from '../components/Uploads/Filters';
import EmptyUploads from './EmptyContainers/Uploads';

import { getVisibleItemsText } from '../helpers';
import { userIsAdmin } from '../helpers/Auth';
import { getUserSetting } from '../helpers/Settings';
import {
  handleComponentParams,
  handleURLParams,
} from '../helpers/URLParams';

import Loading from '../components/Loading';
import ErrorBoundary from '../components/ErrorBoundary';

class Uploads extends Component {
  constructor(props) {
    super(props);

    this.state = {
      uploads: [],
      uploadsTotal: 0,
      uploadsGlobal: 0,
      selectedUser: null,
      page: 1,
      perPage: getUserSetting('admin_per_page') || 20,
      loading: true,
    };

    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangePerPage = this.handleChangePerPage.bind(this);
    this.handleChangeUser = this.handleChangeUser.bind(this);
    this.loadUploads = this.loadUploads.bind(this);
    this.handleUser = this.handleUser.bind(this);
  }

  componentDidUpdate(prevProps) {
    handleComponentParams(
      false,
      ['page', 'perPage', 'user_uuid'],
      prevProps,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'user_uuid')) {
          this.handleUser(updatedParams.user_uuid);
        } else {
          this.loadUploads();
        }
      },
      {
        perPage: getUserSetting('admin_per_page') || 20,
      },
    );
  }

  componentDidMount() {
    handleComponentParams(
      true,
      ['page', 'perPage', 'user_uuid'],
      null,
      this.setState.bind(this),
      (updatedParams) => {
        if (_.has(updatedParams, 'user_uuid')) {
          if (_.has(updatedParams, 'page')) {
            this.handleUser(updatedParams.user_uuid, parseInt(updatedParams.page));
          } else {
            this.handleUser(updatedParams.user_uuid);
          }
        } else {
          this.loadUploads();
        }
      },
      {
        perPage: getUserSetting('admin_per_page') || 20,
      },
    );
  }

  handleUser(userUuid, page = 1) {
    this.setState({ loading: true });

    if (userUuid === null) {
      this.setState({
        selectedUser: null,
      });
      this.handleChangeUser(null, undefined, page);
    } else {
      this.setState({ loading: true });
      APIgetFilesGroupsUsers({ type: 'upload' }).then((res) => {
        const user = res.data.find(u => u.uuid === userUuid);
        if (user) {
          this.setState({ selectedUser: user });
          this.handleChangeUser(user, undefined, page);
        }
      }).catch(() => {
        this.loadUploads();
      });
    }
  }

  loadUploads() {
    const {
      page,
      perPage,
      selectedUser,
    } = this.state;

    this.setState({ loading: true });

    APIgetFilesGroups({
      type: 'upload',
      user_uuid: selectedUser ? selectedUser.uuid : null,
      page,
      per_page: perPage,
    }).then((response) => {
      const { data } = response;
      if (data) {
        this.setState({
          uploads: data.data,
          uploadsTotal: data.meta.total,
          uploadsGlobal: data.meta.total_global,
        }, () => {
          this.setState({ loading: false });
        });
      }
    });
  }

  handleChangePage(page) {
    const { history } = this.props;
    handleURLParams({ page }, history);

    this.setState({ page });
  }

  handleChangePerPage(perPage) {
    const { history } = this.props;
    handleURLParams({ perPage, page: 1 }, history);

    this.setState({ perPage, page: 1 });
  }

  handleChangeUser(user, action, page = 1) {
    const { history } = this.props;
    handleURLParams({ user_uuid: user ? user.uuid : null, page }, history);
    this.setState({
      selectedUser: user,
      page,
    }, () => {
      this.loadUploads();
    });
  }

  render() {
    const {
      selectedUser,
      page,
      perPage,
      uploadsTotal,
      uploadsGlobal,
      loading,
    } = this.state;
    const { profile } = this.props;

    return (
      <div className="main-content uploads-content">
        <Container fluid>
          <UploadsHeader
            profile={profile}
            uploadsTotal={uploadsTotal}
            uploadsVisible={getVisibleItemsText(page, perPage, uploadsTotal)}
            loading={loading}
          />
          {(userIsAdmin() && uploadsGlobal > 0) && (
            <UploadsFilters
              loading={loading}
              selectedUser={selectedUser}
              handleChangeUser={this.handleChangeUser}
            />
          )}
          {loading ? (
            <Loading />
          ) : (
            <div className="content-wrapper">
              {uploadsGlobal === 0 ? (
                <EmptyUploads />
              ) : (
                <>
                  <ErrorBoundary>
                    <UploadsList
                      {...this.state}
                      profile={profile}
                      handleChangeOrder={this.handleChangeOrder}
                      loadUploads={() => {
                        this.loadUploads();
                      }}
                    />
                  </ErrorBoundary>
                  <ErrorBoundary>
                    <UploadsFooter
                      {...this.state}
                      handleChangePage={this.handleChangePage}
                      handleChangePerPage={this.handleChangePerPage}
                    />
                  </ErrorBoundary>
                </>
              )}
            </div>
          )}
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

Uploads.propTypes = {
  profile: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(connect(mapStateToProps)(Uploads));
